// extracted by mini-css-extract-plugin
export default {"pagination":"AdminConversationTicketsList_pagination_t49KC","searchContainer":"AdminConversationTicketsList_searchContainer_gS_PN"};